<script setup>

import { computed } from 'vue'
import { useTheme } from '@/composables/useTheme'
import AppIcon from '@/components/icons/AppIcon.vue'

const { theme, toggleTheme } = useTheme()

const isDark = computed(() => theme.value === 'dark')
const label = computed(() =>
  isDark.value ? 'Switch to light theme' : 'Switch to dark theme'
)
</script>

<template>
  <button class="theme-toggle" :aria-label="label" :title="label" @click="toggleTheme">
    <AppIcon :name="isDark ? 'sun' : 'moon'" :size="20" />
  </button>
</template>

<style scoped>
.theme-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--radius-pill);
  color: var(--text-muted);
  transition: background-color var(--transition), color var(--transition);
}
.theme-toggle:hover {
  background: var(--bg-subtle);
  color: var(--text);
}
</style>
